import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { Column, ColumnForSelection } from 'app/models/columns-dialog.models';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDivider } from '@angular/material/divider';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-columns-dialog',
  templateUrl: './columns-dialog.component.html',
  styleUrls: ['./columns-dialog.component.scss'],
  imports: [MatDialogContent, MatCheckbox, MatDivider, MatDialogActions, FormsModule, MatButton],
})
export class ColumnsDialogComponent {
  columns: Column[];
  defaultColumns: string[];

  columnsForSelection: ColumnForSelection[];

  constructor(
    private dialogRef: MatDialogRef<ColumnsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      columns: Column[];
      defaultColumns: string[];
      selectedColumns: string[];
    },
  ) {
    const { columns, defaultColumns, selectedColumns } = data;

    this.columns = columns;
    this.defaultColumns = defaultColumns;

    this.columnsForSelection = this.columns.map((value) => ({
      ...value,
      selected: selectedColumns.includes(value.columnDef),
    }));
  }

  close() {
    this.dialogRef.close();
  }

  apply() {
    const result = this.columnsForSelection.filter((column) => column.selected).map((column) => column.columnDef);
    this.dialogRef.close(result);
  }

  reset() {
    const defaultColumns = this.defaultColumns;
    this.columnsForSelection = this.columns.map((value) => ({
      ...value,
      selected: defaultColumns.includes(value.columnDef),
    }));
  }

  allCompleted(): boolean {
    return this.columnsForSelection.every((x) => x.selected || x.checkboxDisabled);
  }

  someComplete() {
    return !this.allCompleted() && this.columnsForSelection.some((x) => x.selected && !x.checkboxDisabled);
  }

  setAll(checked: boolean) {
    this.columnsForSelection.filter((x) => !x.checkboxDisabled).forEach((x) => (x.selected = checked));
  }
}
